import React from 'react';
import { Box } from "@chakra-ui/react";

const View: React.FC = () => {
    const baseUrl = process.env.REACT_APP_RESERVE_BASE_URL || "https://bespo-staging.blocks-app.com";
    const allowOrigin = React.useMemo(() => {
        try {
            return new URL(baseUrl).origin;
        } catch (e) {
            return "https://bespo-staging.blocks-app.com https://bespo-prod.blocks-app.com";
        }
    }, [baseUrl]);

    return (
        <Box>
            <style>{`p{margin-bottom:0;vertical-align:middle}`}</style>
            <iframe
                src="https://ftt.stg.tablerequest.jp/"
                title="reserve-view-iframe"
                allow={`clipboard-write ${allowOrigin}`}
                style={{width: '100%', height: '100vh'}}
                frameBorder="0"
            ></iframe>
        </Box>
    );
};

export default View;